<script lang="ts">
	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children }: Props = $props();
</script>

<div class="flex flex-col lg:flex-row-reverse px-2 overflow-auto">
	<div class="w-full p-2 sm:p-5 h-full">
		{@render children?.()}
	</div>
</div>
